import { render, staticRenderFns } from "./MasterGroupClassList.vue?vue&type=template&id=998c9744"
import script from "./MasterGroupClassList.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports